import { getContext } from "svelte";
export const getAccordionContext = () => getContext("accordion");
